import React, { SyntheticEvent, useCallback, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  useNavigate,
  useActionData,
  useSubmit,
  useAsyncValue,
} from 'react-router-dom';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

//Components
import ContentCardResume from '../../../../../components/display/ContentCardResume';

// Types
import { type Campaign } from '../../../../../types/campaign';
import { createFormDataFromValues } from '../../../../../utils/forms';
import { variant } from '../../../../../components/display/SpecialTag/types';
import { OrderType } from '../../../../../types/orders';
import { getClassificationName } from '../../../../../utils/orders';

// Redux
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

export default function CampaignSummary(): JSX.Element {
  const { t } = useTranslation(['pages', 'campaigns']);
  const actionData = useActionData() as Campaign;
  const loaderData = useAsyncValue() as Campaign;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const submit = useSubmit();

  const campaignData = actionData ?? loaderData;
  useLayoutEffect(() => {
    if (!campaignData) navigate('..');
    if (campaignData.id) {
      dispatch(
        roidOTSelected(
          'edit-campaign',
          (campaignData.roid as unknown as string[]).join('.'),
          campaignData.id
        )
      );
    }
  }, []);

  const handleEditCampaign = useCallback(() => {
    navigate(`../${campaignData?.id ? campaignData?.id : ''}`);
  }, [campaignData?.id]);

  const handleSaveCampaign = async (e: SyntheticEvent) => {
    e.preventDefault();
    let formDataRaw: {
      intent: string;
      id?: string;
    } = {
      intent: 'save-data',
    };
    if (campaignData?.id) {
      formDataRaw = {
        ...formDataRaw,
        ...(campaignData?.changesCampaign ?? {}),
      };
    }

    const formData = createFormDataFromValues(formDataRaw);
    submit(formData, {
      method: 'POST',
      action: '.',
    });
  };

  return (
    <>
      {campaignData && (
        <ContentCardResume
          title={
            campaignData.campaign
              ? t('campaigns:summary')
              : t('pages:workOrders.summary')
          }
          roid={loaderData.roid}
          tag={campaignData.campaign ? variant.Campaign : undefined}
          tagContent={campaignData.campaign ? campaignData.campaign : undefined}
          operator={campaignData.operator}
          data={format(
            new Date(campaignData.registerInitDate),
            'dd / MM / yyyy'
          )}
          hour={format(new Date(campaignData.registerInitDate), 'HH:mm')}
          capitol={campaignData.capitol}
          subCapitol={campaignData.subCapitol}
          classification={getClassificationName(
            campaignData.classification,
            loaderData.classifications
          )}
          team={campaignData.team}
          concession={campaignData.concession}
          road={campaignData.road}
          pkInit={`${campaignData.pkInit} km`}
          pkEnd={`${campaignData.pkEnd} km`}
          track={campaignData.track}
          roadDirections={campaignData.roadDirections}
          direction={campaignData?.direction}
          city={campaignData.city}
          lane={campaignData.lane}
          margin={campaignData?.margin}
          leftButton={'Editar O.T'}
          rightButton={'Desar'}
          description={campaignData.description}
          notes={campaignData.notes}
          orderType={OrderType.Campaign}
          onEditCommunication={handleEditCampaign}
          onSaveCommunication={handleSaveCampaign}
        />
      )}
    </>
  );
}
